export default __webpack_public_path__ + "static/media/IconArrowLeft.3742a233.svg";